import * as Sentry from '@sentry/browser';
import generateUuid from './generateUuid';

const contextTypes = {
	audio: 'Audio',
	screen: 'Screen'
};

if (process.env.SENTRY_ENABLED) {
	Sentry.init({
		dsn: 'https://30ab60c8d20b44c18a9671e2a8124c42@o27497.ingest.sentry.io/1453309',
		release: `plecto-screen@${process.env.VERSION}`,
		environment: process.env.SENTRY_ENVIRONMENT,
		denyUrls: [
			/service\.force\.com/i,
			/partners\.plecto\.com/i,
			/extensions\//i,
			/^chrome:\/\//i,
			/^chrome-extension:\/\//i,
			/^safari-extension:\/\//i,
			/^safari-web-extension:\/\//i,
			/embeddedservice/i,
			/connect\.facebook/i,
		],
	});
}

export default function isSentryEnabled() {
	return process.env.SENTRY_ENABLED;
}

export function setSentryContext(screenId) {
	if (isSentryEnabled()) {
		Sentry.setContext(contextTypes.screen, {
			id: screenId,
			session: generateUuid(),
		});
		Sentry.setContext(contextTypes.audio, {
			mode: 'sound source'
		});
	}
}

export function setSentryAudioMode(mode) {
	if (isSentryEnabled()) {
		Sentry.setContext(contextTypes.audio, {
			mode
		});
	}
}
